import PropTypes from "prop-types";

const TextInput = ({
  name,
  title,
  type,
  value,
  error,
  handleChange,
  placeholder,
  className,
  page,
  style,
}) => {
  const iconMap = {
    email: "bi-envelope-fill",
    password: "bi-lock-fill",
    username: "bi-person-fill",
    phone: "bi-telephone-fill",
    search: "bi-search",
    referralCode: "bi-gift-fill",
    agentCode: "bi-gift-fill",
  };

  const iconClass = iconMap[name];
  return (
    <div className={`${page ? "" : "mb-2"}   text-start`}>
      {title && (
        <label className="d-flex align-items-center fs-12 mb-1 form-label">
          <span className="required">{title}</span>
        </label>
      )}
      <div className="position-relative">
        {iconClass && (
          <i
            className={`bi ${iconClass} text-muted position-absolute top-50 start-0 translate-middle-y ms-3`}
            style={{ pointerEvents: "none" }}
          ></i>
        )}
        <input
          type={type}
          // className={className ? className : "form-control  form-control-solid"}
          className={
            className
              ? className
              : `form-control form-control-solid ${iconClass ? "ps-5" : ""}`
          }
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={(e) => {
            handleChange(e);
          }}
          style={style}
        />
      </div>
      {name !== "referralCode" && (
        <div style={page ? { height: "20px" } : {}} className="mb-2">
          <span className="fs-10 text-danger ps-3">{error}</span>
        </div>
      )}
    </div>
  );
};

TextInput.prototype = {
  name: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.any,
  error: PropTypes.string,
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  page: PropTypes.string,
  style: PropTypes.any,
};
export default TextInput;
